import { css } from "styled-components";
import { UserLevel } from "project-config/constants";
import Normal from "../icons/normal";
import Silver from "../icons/silver";
import Gold from "../icons/gold";
import Platinum from "../icons/platium";
import Diamond from "../icons/diamond";
import DiamondStudent from "../icons/diamond-student";
import PictureNormal from "../icons/picture-normal";
import PictureVIP from "../icons/picture-vip";

export const getUserLevelIcon = (level: number) => {
  return {
    [UserLevel.PictureNormal]: <PictureNormal />,
    [UserLevel.PictureVip]: <PictureVIP />,
    [UserLevel.Normal]: <Normal />,
    [UserLevel.Sliver]: <Silver />,
    [UserLevel.Gold]: <Gold />,
    [UserLevel.Platinum]: <Platinum />,
    [UserLevel.Diamond]: <Diamond />,
    [UserLevel.DiamondStudent]: <DiamondStudent />,
    [UserLevel.DiamondAnimationGift]: <DiamondStudent />,
  }[level];
};

export const getUserLevelStyle = (level: number) => {
  const commonStyle = css`
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  `;
  return {
    [UserLevel.PictureNormal]: css``,
    [UserLevel.PictureVip]: css`
      ${commonStyle};
      background: linear-gradient(
        90.44deg,
        #f4f3fc 0%,
        #d6c2ff 54.17%,
        #99b7ff 100%
      );
    `,
    [UserLevel.Normal]: css``,
    [UserLevel.Sliver]: css`
      ${commonStyle};
      background: linear-gradient(90deg, #d2e3fc 0.28%, #b2caec 99.86%);
    `,
    [UserLevel.Gold]: css`
      ${commonStyle};
      background: linear-gradient(
        90.44deg,
        #ffdfae 0%,
        #ffc266 51.56%,
        #ffcf7e 100%
      );
    `,
    [UserLevel.Platinum]: css`
      ${commonStyle};
      background: linear-gradient(
        93.26deg,
        #f4f3fc 0%,
        #d6c2ff 49.36%,
        #99b7ff 91.13%
      );
    `,
    [UserLevel.Diamond]: css`
      background: linear-gradient(280.88deg, #f3b073 12.69%, #ffe3ca 109.28%);
      ${commonStyle};
    `,
    [UserLevel.DiamondStudent]: css`
      background: linear-gradient(280.88deg, #f3b073 12.69%, #ffe3ca 109.28%);
      ${commonStyle};
    `,
    [UserLevel.DiamondAnimationGift]: css`
      background: linear-gradient(280.88deg, #f3b073 12.69%, #ffe3ca 109.28%);
      ${commonStyle};
    `,
  }[level];
};

export const getProgressBarColor = (level: number) => {
  return {
    [UserLevel.Normal]:
      "linear-gradient(278.31deg, #13CB75 1.9%, #13CB9F 91.73%)",
    [UserLevel.Sliver]: "linear-gradient(90deg, #7297E2 0%, #BDD7FF 100%)",
    [UserLevel.Gold]: "linear-gradient(270deg, #FDB87D 0%, #FFA349 100%)",
    [UserLevel.Platinum]:
      "linear-gradient(90deg, #B4C0FE 0%, #9176FC 53.46%, #3D2FFF 100%)",
    [UserLevel.Diamond]:
      "linear-gradient(270deg, #EDAE3A 0%, #ED8A4B 54.69%, #F0CC89 100%)",
    [UserLevel.DiamondStudent]:
      "linear-gradient(270deg, #EDAE3A 0%, #ED8A4B 54.69%, #F0CC89 100%)",
    [UserLevel.DiamondAnimationGift]:
      "linear-gradient(270deg, #EDAE3A 0%, #ED8A4B 54.69%, #F0CC89 100%)",
  }[level];
};
